module.exports = __webpack_public_path__ + "images/motorbike.c396087ff97a57bb1057c9ca088ee836.svg";